/* tslint:disable */
/* eslint-disable */
/**
 * AffiliationCloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetAdvertiserSitesBasicPair200Response } from '../AfClApiModels';
// @ts-ignore
import { GetPublisherProgramsDiscoverByBrand200Response } from '../AfClApiModels';
// @ts-ignore
import { PublisherProgramDetails } from '../AfClApiModels';
/**
 * PublisherProgramsApi - axios parameter creator
 * @export
 */
export const PublisherProgramsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns Program details with publisher redirect links
         * @summary Get Publisher Program details
         * @param {number} publisherId Numeric ID of the publisher to find
         * @param {number} programId Numeric ID of the program to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherProgramDetails: async (publisherId: number, programId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publisherId' is not null or undefined
            assertParamExists('getPublisherProgramDetails', 'publisherId', publisherId)
            // verify required parameter 'programId' is not null or undefined
            assertParamExists('getPublisherProgramDetails', 'programId', programId)
            const localVarPath = `/v1/publishers/{publisherId}/programs/{programId}`
                .replace(`{${"publisherId"}}`, encodeURIComponent(String(publisherId)))
                .replace(`{${"programId"}}`, encodeURIComponent(String(programId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns Programs that are compatible with the Sites of the Publisher, based on subscriptions.
         * @summary Get Publisher Programs
         * @param {number} publisherId Numeric ID of the publisher to find
         * @param {string} [name] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherPrograms: async (publisherId: number, name?: string, page?: number, perPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publisherId' is not null or undefined
            assertParamExists('getPublisherPrograms', 'publisherId', publisherId)
            const localVarPath = `/v1/publishers/{publisherId}/programs`
                .replace(`{${"publisherId"}}`, encodeURIComponent(String(publisherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all available (active) programs that AC offers
         * @summary Get Publisher Programs Discover By Brand
         * @param {number} publisherId Numeric ID of the publisher to find
         * @param {string} [name] Used to filter by program name
         * @param {boolean} [notJoined] When TRUE, only brands with programs the publisher hasn’t joined yet will be included. When FALSE, NULL, or missing, include all active programs of the brand.
         * @param {number} [brandId] Used to filter by brand ID
         * @param {number} [regionId] Has programs in this region
         * @param {number} [verticalId] Has programs with this vertical
         * @param {Array<string>} [programLabelNames] Has programs with these labels
         * @param {string} [dealCommissionModel] Has programs with these commission models
         * @param {'COMING_SOON' | 'NEW' | 'ACTIVE' | 'INACTIVE' | 'DUPLICATED'} [programsStatus] 
         * @param {number} [page] Page to show
         * @param {number} [perPage] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherProgramsDiscoverByBrand: async (publisherId: number, name?: string, notJoined?: boolean, brandId?: number, regionId?: number, verticalId?: number, programLabelNames?: Array<string>, dealCommissionModel?: string, programsStatus?: 'COMING_SOON' | 'NEW' | 'ACTIVE' | 'INACTIVE' | 'DUPLICATED', page?: number, perPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publisherId' is not null or undefined
            assertParamExists('getPublisherProgramsDiscoverByBrand', 'publisherId', publisherId)
            const localVarPath = `/v1/publishers/{publisherId}/programs/discover`
                .replace(`{${"publisherId"}}`, encodeURIComponent(String(publisherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (notJoined !== undefined) {
                localVarQueryParameter['not_joined'] = notJoined;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brand_id'] = brandId;
            }

            if (regionId !== undefined) {
                localVarQueryParameter['region_id'] = regionId;
            }

            if (verticalId !== undefined) {
                localVarQueryParameter['vertical_id'] = verticalId;
            }

            if (programLabelNames) {
                localVarQueryParameter['program_label_names[]'] = programLabelNames;
            }

            if (dealCommissionModel !== undefined) {
                localVarQueryParameter['deal_commission_model'] = dealCommissionModel;
            }

            if (programsStatus !== undefined) {
                localVarQueryParameter['programs_status'] = programsStatus;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublisherProgramsApi - functional programming interface
 * @export
 */
export const PublisherProgramsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublisherProgramsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns Program details with publisher redirect links
         * @summary Get Publisher Program details
         * @param {number} publisherId Numeric ID of the publisher to find
         * @param {number} programId Numeric ID of the program to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublisherProgramDetails(publisherId: number, programId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublisherProgramDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublisherProgramDetails(publisherId, programId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns Programs that are compatible with the Sites of the Publisher, based on subscriptions.
         * @summary Get Publisher Programs
         * @param {number} publisherId Numeric ID of the publisher to find
         * @param {string} [name] 
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublisherPrograms(publisherId: number, name?: string, page?: number, perPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdvertiserSitesBasicPair200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublisherPrograms(publisherId, name, page, perPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all available (active) programs that AC offers
         * @summary Get Publisher Programs Discover By Brand
         * @param {number} publisherId Numeric ID of the publisher to find
         * @param {string} [name] Used to filter by program name
         * @param {boolean} [notJoined] When TRUE, only brands with programs the publisher hasn’t joined yet will be included. When FALSE, NULL, or missing, include all active programs of the brand.
         * @param {number} [brandId] Used to filter by brand ID
         * @param {number} [regionId] Has programs in this region
         * @param {number} [verticalId] Has programs with this vertical
         * @param {Array<string>} [programLabelNames] Has programs with these labels
         * @param {string} [dealCommissionModel] Has programs with these commission models
         * @param {'COMING_SOON' | 'NEW' | 'ACTIVE' | 'INACTIVE' | 'DUPLICATED'} [programsStatus] 
         * @param {number} [page] Page to show
         * @param {number} [perPage] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublisherProgramsDiscoverByBrand(publisherId: number, name?: string, notJoined?: boolean, brandId?: number, regionId?: number, verticalId?: number, programLabelNames?: Array<string>, dealCommissionModel?: string, programsStatus?: 'COMING_SOON' | 'NEW' | 'ACTIVE' | 'INACTIVE' | 'DUPLICATED', page?: number, perPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublisherProgramsDiscoverByBrand200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublisherProgramsDiscoverByBrand(publisherId, name, notJoined, brandId, regionId, verticalId, programLabelNames, dealCommissionModel, programsStatus, page, perPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublisherProgramsApi - factory interface
 * @export
 */
export const PublisherProgramsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublisherProgramsApiFp(configuration)
    return {
        /**
         * Returns Program details with publisher redirect links
         * @summary Get Publisher Program details
         * @param {PublisherProgramsApiGetPublisherProgramDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherProgramDetails(requestParameters: PublisherProgramsApiGetPublisherProgramDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<PublisherProgramDetails> {
            return localVarFp.getPublisherProgramDetails(requestParameters.publisherId, requestParameters.programId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns Programs that are compatible with the Sites of the Publisher, based on subscriptions.
         * @summary Get Publisher Programs
         * @param {PublisherProgramsApiGetPublisherProgramsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherPrograms(requestParameters: PublisherProgramsApiGetPublisherProgramsRequest, options?: AxiosRequestConfig): AxiosPromise<GetAdvertiserSitesBasicPair200Response> {
            return localVarFp.getPublisherPrograms(requestParameters.publisherId, requestParameters.name, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all available (active) programs that AC offers
         * @summary Get Publisher Programs Discover By Brand
         * @param {PublisherProgramsApiGetPublisherProgramsDiscoverByBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherProgramsDiscoverByBrand(requestParameters: PublisherProgramsApiGetPublisherProgramsDiscoverByBrandRequest, options?: AxiosRequestConfig): AxiosPromise<GetPublisherProgramsDiscoverByBrand200Response> {
            return localVarFp.getPublisherProgramsDiscoverByBrand(requestParameters.publisherId, requestParameters.name, requestParameters.notJoined, requestParameters.brandId, requestParameters.regionId, requestParameters.verticalId, requestParameters.programLabelNames, requestParameters.dealCommissionModel, requestParameters.programsStatus, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPublisherProgramDetails operation in PublisherProgramsApi.
 * @export
 * @interface PublisherProgramsApiGetPublisherProgramDetailsRequest
 */
export interface PublisherProgramsApiGetPublisherProgramDetailsRequest {
    /**
     * Numeric ID of the publisher to find
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherProgramDetails
     */
    readonly publisherId: number

    /**
     * Numeric ID of the program to find
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherProgramDetails
     */
    readonly programId: number
}

/**
 * Request parameters for getPublisherPrograms operation in PublisherProgramsApi.
 * @export
 * @interface PublisherProgramsApiGetPublisherProgramsRequest
 */
export interface PublisherProgramsApiGetPublisherProgramsRequest {
    /**
     * Numeric ID of the publisher to find
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherPrograms
     */
    readonly publisherId: number

    /**
     * 
     * @type {string}
     * @memberof PublisherProgramsApiGetPublisherPrograms
     */
    readonly name?: string

    /**
     * 
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherPrograms
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherPrograms
     */
    readonly perPage?: number
}

/**
 * Request parameters for getPublisherProgramsDiscoverByBrand operation in PublisherProgramsApi.
 * @export
 * @interface PublisherProgramsApiGetPublisherProgramsDiscoverByBrandRequest
 */
export interface PublisherProgramsApiGetPublisherProgramsDiscoverByBrandRequest {
    /**
     * Numeric ID of the publisher to find
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly publisherId: number

    /**
     * Used to filter by program name
     * @type {string}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly name?: string

    /**
     * When TRUE, only brands with programs the publisher hasn’t joined yet will be included. When FALSE, NULL, or missing, include all active programs of the brand.
     * @type {boolean}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly notJoined?: boolean

    /**
     * Used to filter by brand ID
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly brandId?: number

    /**
     * Has programs in this region
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly regionId?: number

    /**
     * Has programs with this vertical
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly verticalId?: number

    /**
     * Has programs with these labels
     * @type {Array<string>}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly programLabelNames?: Array<string>

    /**
     * Has programs with these commission models
     * @type {string}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly dealCommissionModel?: string

    /**
     * 
     * @type {'COMING_SOON' | 'NEW' | 'ACTIVE' | 'INACTIVE' | 'DUPLICATED'}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly programsStatus?: 'COMING_SOON' | 'NEW' | 'ACTIVE' | 'INACTIVE' | 'DUPLICATED'

    /**
     * Page to show
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly page?: number

    /**
     * Items per page
     * @type {number}
     * @memberof PublisherProgramsApiGetPublisherProgramsDiscoverByBrand
     */
    readonly perPage?: number
}

/**
 * PublisherProgramsApi - object-oriented interface
 * @export
 * @class PublisherProgramsApi
 * @extends {BaseAPI}
 */
export class PublisherProgramsApi extends BaseAPI {
    /**
     * Returns Program details with publisher redirect links
     * @summary Get Publisher Program details
     * @param {PublisherProgramsApiGetPublisherProgramDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherProgramsApi
     */
    public getPublisherProgramDetails(requestParameters: PublisherProgramsApiGetPublisherProgramDetailsRequest, options?: AxiosRequestConfig) {
        return PublisherProgramsApiFp(this.configuration).getPublisherProgramDetails(requestParameters.publisherId, requestParameters.programId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns Programs that are compatible with the Sites of the Publisher, based on subscriptions.
     * @summary Get Publisher Programs
     * @param {PublisherProgramsApiGetPublisherProgramsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherProgramsApi
     */
    public getPublisherPrograms(requestParameters: PublisherProgramsApiGetPublisherProgramsRequest, options?: AxiosRequestConfig) {
        return PublisherProgramsApiFp(this.configuration).getPublisherPrograms(requestParameters.publisherId, requestParameters.name, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all available (active) programs that AC offers
     * @summary Get Publisher Programs Discover By Brand
     * @param {PublisherProgramsApiGetPublisherProgramsDiscoverByBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherProgramsApi
     */
    public getPublisherProgramsDiscoverByBrand(requestParameters: PublisherProgramsApiGetPublisherProgramsDiscoverByBrandRequest, options?: AxiosRequestConfig) {
        return PublisherProgramsApiFp(this.configuration).getPublisherProgramsDiscoverByBrand(requestParameters.publisherId, requestParameters.name, requestParameters.notJoined, requestParameters.brandId, requestParameters.regionId, requestParameters.verticalId, requestParameters.programLabelNames, requestParameters.dealCommissionModel, requestParameters.programsStatus, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
}
